import { JsonServiceClient } from "@servicestack/client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as DTOS from "../FeralScan.dtos";

export const serviceApi = {
    getSurveyResults: (groupId: number, userId: number, surveyCode: string, plotEventCreatedStartDate: any, plotEventCreatedEndDate: any) => {
        var client = new JsonServiceClient("");
        var request = new DTOS.GetSummarySurveyResults();

        request.groupId = groupId;
        request.userId = userId;
        request.surveyCode = surveyCode;
        request.plotEventCreatedStartDate = plotEventCreatedStartDate ? plotEventCreatedStartDate.toJSON() : undefined;
        request.plotEventCreatedEndDate = plotEventCreatedEndDate ? plotEventCreatedEndDate.toJSON() : undefined;;

        const promise = client.get(request);
        return Observable.from(promise);
    },
    getPlotEventsCount: (groupId: number, userId: number, plotEventStartDateStart: any, plotEventStartDateEnd: any, classificationIds: number[], mustIncludeClassificationId?: number) => {
        var client = new JsonServiceClient("");
        var request = new DTOS.GetSummaryPlotEventsCount();

        request.groupId = groupId;
        request.userId = userId;
        request.plotEventStartDateStart = plotEventStartDateStart ? plotEventStartDateStart.toJSON() : undefined;
        request.plotEventStartDateEnd = plotEventStartDateEnd ? plotEventStartDateEnd.toJSON() : undefined;
        request.classificationIds = classificationIds;
        request.mustIncludeClassificationId = mustIncludeClassificationId;

        const promise = client.get(request);
        return Observable.from(promise);
    },
    getMetadata: (groupId?: number, userId?: number) => {
        var client = new JsonServiceClient("");
        var request = new DTOS.GetSummaryMetadata();

        request.groupId = groupId;
        request.userId = userId;

        const promise = client.get(request);
        return Observable.from(promise);
    }
};
